module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-engagements-icon-save-earth.734aca13.svg";